export default __webpack_public_path__ + "static/media/smartle_landing.f3c22606.png";